<template>
  <c-input-container
    class="c-radio-button"
    v-bind="$attrs"
  >
    <c-radio-raw
      v-bind="$attrs"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </c-input-container>
</template>

<script>
import CInputContainer from '@convenia/components/CInputContainer'
import CRadioRaw from './fragments/CRadioRaw'

export default {
  name: 'CRadioButton',

  components: { CInputContainer, CRadioRaw },

  emits: [
    'update:modelValue',
    'hint:show',
    'hint:hide',
    'input'
  ]
}
</script>
